import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class WebChannelAuthConfig
*  Настройки веб-витрины по регистрации/авторизации
*/
export class WebChannelAuthConfig extends ActiveModel {

  /**
  * allowEmailLogin
  * Разрешены ли Email-адреса в качестве логина<br>  */
  @ActiveField(false)
  allowEmailLogin: boolean = false


  /**
  * allowPhoneLogin
  * Разрешены ли номера телефонов в качестве логина<br>  */
  @ActiveField(false)
  allowPhoneLogin: boolean = false
}
